
namespace RioERP.Carts {
    export class CartProductBillingItemsColumns {
        static columnsKey = 'Carts.CartProductBillingItems';
    }
}